import React, {FunctionComponent} from 'react';
import {Route, Routes} from "react-router-dom";
import {GeneralSection} from "../../../sections/GeneralSection/GeneralSection";
import {ContractSection} from "../../../sections/ContractSection/ContractSection";
import {NotesSection} from "../../../sections/NotesSection/NotesSection";
import {FilesSection} from "../../../sections/FilesSection/FilesSection";
import {CommentSection} from "../../../sections/CommentSection/CommentSection";
import {CommentProvider} from "../../../context/CommentContext";
import {ActivitySection} from "../../../sections/ActivitySection/ActivitySection";
import {InvoiceProviders} from "../../InvoiceProviders/InvoiceProviders";

interface MainContentProps {

}

export const MainContent: FunctionComponent<MainContentProps> = () => {
    return (
        <InvoiceProviders>
            <Routes>
                <Route path='/' element={<GeneralSection/>}></Route>
            </Routes>


            <Routes>
                <Route path='/files' element={<FilesSection/>}></Route>
            </Routes>

            <CommentProvider>
                <Routes>
                    <Route path='/comments'
                           element={<CommentSection/>}></Route>
                </Routes>
            </CommentProvider>

            <Routes>
                <Route path='/activity'
                       element={<ActivitySection/>}></Route>
            </Routes>

            <Routes>
                <Route path='/contract'
                       element={<ContractSection/>}></Route>
                <Route path='/notes' element={<NotesSection/>}></Route>
            </Routes>
        </InvoiceProviders>
    );
}
